import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { LivenviroUser, UserSlice } from './types';

const initialState: UserSlice = {
  id: null,
  account: null,
  role: null,
  api_key: null,
  user_name: null,
  email: null,
  first_name: null,
  last_name: null,
  permitted_actions: null,
  permitted_stations: null,
  current: true,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserSlice>) => {
      return action.payload;    
    },
  }
});

export const { setUser } = userSlice.actions;

export const selectUser = (state: RootState) => {
  return state.user
};

/**
 * Converts Livenviro user passed through iFrame to one usable by the app.
 */
export const prepareLivenviroUser = (user : LivenviroUser) : UserSlice => {
  
  // Only the id of account is taken from global key of object
  // As masquerade is assigned to that key, no to the nested object
  let account = {
    id: user.account_id,
    title: user.account.title
  }

  return { 
    id: user.id,
    account: account,
    role: user.role,
    api_key: user.api_key.key,
    user_name: user.user_name,
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name,
    permitted_actions: user.permitted_actions,
    permitted_stations: user.permitted_stations
  }
}

export default userSlice.reducer;

